import { useEffect, useState } from 'preact/hooks';
import { back, navigate } from '@/state/nav';
import { db } from '@/lib/db';
import { sendMessage } from '@/state/chat';
import { Icon } from '@/components/Icon';
import type { Report } from '@/types';

const TYPE_LABEL: Record<Report['rtype'], string> = {
  handoff: 'Shift handoff',
  daily: 'Daily summary',
  weekly: 'Weekly summary',
  per_animal: 'Animal report',
  audit: 'Audit',
};

export function ReportsScreen() {
  const [reports, setReports] = useState<Report[]>([]);

  useEffect(() => {
    void db.reports.orderBy('created_at').reverse().limit(60).toArray().then(setReports);
  }, []);

  const generate = () => {
    navigate('/');
    void sendMessage('Generate the shift handoff report for everything since this morning.');
  };

  return (
    <div class="screen screen--no-tabbar screen--fade-in">
      <header class="header header--sub">
        <button class="iconbtn" aria-label="Back" onClick={() => back('/more')}>
          <Icon name="chevron-left" size={20} />
        </button>
        <div>
          <div class="header__title">Reports</div>
        </div>
      </header>

      <button class="rep-cta" onClick={generate}>
        <span class="rep-cta__icon">
          <Icon name="doc" size={20} />
        </span>
        <span style={{ flex: 1 }}>
          <div class="rep-cta__title">Generate shift handoff</div>
          <div class="rep-cta__sub">Tend writes it from today's log — you just read it to the next keeper</div>
        </span>
        <Icon name="chevron-right" size={18} />
      </button>

      <div class="scroll" style={{ gap: '8px' }}>
        {reports.length === 0 && (
          <p class="roster-empty">No reports yet — generate the first handoff above.</p>
        )}
        {reports.map((r) => (
          <button key={r.id} class="rep-item" onClick={() => navigate(`/reports/${r.id}`)}>
            <span class="suggest-chip__icon" style={{ width: '34px', height: '34px' }}>
              <Icon name="doc" size={16} />
            </span>
            <span class="rep-item__main">
              <div class="rep-item__title">{r.title}</div>
              <div class="rep-item__meta">
                {TYPE_LABEL[r.rtype]} ·{' '}
                {new Date(r.created_at).toLocaleString([], {
                  weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
                })}
              </div>
            </span>
            <Icon name="chevron-right" size={16} class="t-meta" />
          </button>
        ))}
      </div>
    </div>
  );
}
